<template>
  <div>
    <div v-if="ready" class="tab-pane pt-3 active show" :key="reload">
      <div class="insurance-editor">
        <div class="row">
          <div class="col-12">
            <h4>
              <span class="text-thin">分類：</span>同業保單(含保代件)-附約
            </h4>
            <form class="form" :class="{'section-loading': this.isLoading}">
              <div class="panel panel-form">
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>公司別
                  </label>
                  <div class="col-9" style="display: none">
                    <span class="text"></span>
                  </div>
                  <div class="col-9">
                    <span class="text">
                      {{ currentCompany ? currentCompany.COMPSNM : "" }}
                    </span>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right"
                    ><span class="text-red">*</span>契約別
                  </label>
                  <div class="col-9"><span class="text">附約</span></div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>險種
                  </label>
                  <div class="col-7" v-if="isUpdate">
                    <span class="text">{{
                      _.get(
                        options.insuranceTypes.find(
                          (i) => i.PRODUCTID === editData.productid
                        ),
                        "NAME"
                      )
                    }}</span>
                  </div>
                  <div class="col-7" v-else>
                    <v-select
                      v-if="options.insuranceTypes.length"
                      v-model="editData.productid"
                      :options="options.insuranceTypes"
                      label="NAME"
                      :reduce="(item) => item.PRODUCTID"
                      placeholder="請選擇或輸入"
                      data-vv-name="productid"
                      :class="{ 'is-invalid': errors.has(`productid`) }"
                      v-validate="'required'"
                      @input="onInsuranceChange()"
                    >
                      <div slot="no-options">沒有資料可供選擇 !</div>
                    </v-select>
                    <span v-else class="text">請先選擇公司別</span>
                  </div>
                  <span v-if="!isUpdate" class="text" @click="panelOpen('mvPopUpProductPrompt')">
                    <a class="link text-underline">找不到商品?</a>
                  </span>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>主被保人
                  </label>
                  <div class="col-9">
                    <template
                      v-if="options.families.length && isCsidnoNotInFamilies"
                    >
                      <b class="text px-3 text-green">
                        {{
                          (csidnoName || $route.query.csidnoName)
                            | truncate
                        }}
                      </b>
                      <a class="btn btn-red m-0" @click="editData.csidno = ''">
                        刪除
                      </a>
                    </template>
                    <template v-else>
                      <select
                        class="form-control form-control-inline form-wide"
                        data-vv-name="csidno"
                        :class="{ 'is-invalid': errors.has(`csidno`) }"
                        v-validate="'required'"
                        v-model="editData.csidno"
                        @change="(e) => onCsidnoChange(e.target.value)"
                        alt="ch"
                      >
                        <option value="">請選擇</option>
                        <option
                          v-for="(item, index) in options.families"
                          :key="index"
                          :value="item.csidno"
                        >
                          {{ item.name | truncate }}
                        </option>
                        <!--<option value="search">選擇現有客戶</option>-->
                      </select>
                    </template>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>年期
                  </label>
                  <div class="col-9">
                    <select
                      v-if="options.annual.length"
                      class="form-control form-control-inline"
                      data-vv-name="prd"
                      :class="{ 'is-invalid': errors.has(`prd`) }"
                      v-validate="'required'"
                      v-model="editData.prd"
                    >
                      <option value="">請選擇</option>
                      <option
                        v-for="(item, index) in options.annual"
                        :key="index"
                        :value="item.value"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <span class="text" v-else>請選擇險種</span>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>繳別
                  </label>
                  <div class="col-9">
                    <select
                      class="form-control form-control-inline"
                      data-vv-name="pay_freq"
                      :class="{ 'is-invalid': errors.has('pay_freq') }"
                      v-validate="'required'"
                      v-model="editData.pay_freq"
                    >
                      <option value="">請選擇</option>
                      <option
                        v-for="(n, v) in optionPaymentWayList"
                        :key="v"
                        :value="v"
                      >
                        {{ n }}
                      </option>
                    </select>
                  </div>
                </div>
                <roc-date-picker
                  title="投保日期"
                  :year.sync="editData.year"
                  :month.sync="editData.month"
                  :day.sync="editData.day"
                  :inValid="isRdstdtError"
                  :isCustomYearOption="true"
                  :startROCYear="34"
                  :endROCYear="thisROCYear"
                >
                  <div class="error-block d-inline-block mb-0">
                    <div class="error">
                      *
                      <span class="text-black">不得超過當天日期</span>
                    </div>
                  </div></roc-date-picker
                >
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>保額/計畫別
                  </label>
                  <div class="col-9">
                    <input
                      type="text"
                      :maxlength="currentInsuranceType.UNIT == 3 ? 4 : 8"
                      class="form-control form-control-inline"
                      v-if="!usePlan"
                      data-vv-name="famt"
                      :class="{ 'is-invalid': errors.has(`famt`) }"
                      v-number.lazy.clear
                      v-validate="'required|decimal:2'"
                      v-model="editData.famt"
                      @input="checkDecimal2(editData.famt, 'famt')"
                    />
                    <select
                      class="form-control form-control-inline"
                      style="width: 200px"
                      v-else
                      data-vv-name="sche"
                      :class="{ 'is-invalid': errors.has(`sche`) }"
                      v-validate="'required'"
                      v-model="editData.sche"
                      @change="onScheChange()"
                    >
                      <option value="">請選擇</option>
                      <option
                        v-for="(item, index) in options.plan"
                        :key="index"
                        :value="item"
                      >
                        計畫{{ item.NAME }}：{{ String(item.NAME).includes('_1') ? '' : '日額' }}{{ item.QUANTITY }}元
                      </option>
                    </select>
                    <span class="text">
                      {{ translate.unit[currentInsuranceType.UNIT] }}
                    </span>
                    <span v-if="showCurrencyType" class="text"
                      >({{
                        translate.currencytypeTW[
                          currentInsuranceType.CURRENCYTYPE
                        ]
                      }})</span
                    >
                    <div
                      v-if="editData.companyid == 'f5040bcf5f2f42e2bce5793ac5b36238'"
                      class="error-block d-inline-block mb-0"
                    >
                      <div class="error">
                        *
                        <span class="text-black">新光防癌險一單位50萬</span>
                      </div>
                    </div>
                    <div
                      v-if="insuranceTypesIsExempt"
                      class="error-block d-inline-block mb-0"
                    >
                      <span class="text-black">(豁免附約的保額為0)</span>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>保費
                  </label>
                  <div class="col-9">
                    <input
                      type="text"
                      maxlength="9"
                      class="form-control form-control-inline"
                      data-vv-name="prem"
                      :class="{ 'is-invalid': errors.has(`prem`) }"
                      v-number.lazy.clear
                      v-validate="'required|decimal:2'"
                      v-model="editData.prem"
                      @input="checkDecimal2(editData.prem, 'prem')"
                    />
                    <span class="text">
                      {{
                        translate.currencytypeTW[
                          currentInsuranceType.CURRENCYTYPE
                        ]
                      }}
                    </span>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">保單價值</label>
                  <div class="col-9">
                    <input
                      type="text"
                      maxlength="13"
                      class="form-control form-control-inline"
                      data-vv-name="plcvl"
                      :class="{ 'is-invalid': errors.has(`plcvl`) }"
                      v-number.lazy.clear
                      v-validate="'decimal:2'"
                      v-model="editData.plcvl"
                      @input="checkDecimal2(editData.plcvl, 'plcvl')"
                    />
                    <span v-if="showCurrencyType" class="text"
                      >({{
                        translate.currencytypeTW[
                          currentInsuranceType.CURRENCYTYPE
                        ]
                      }})</span
                    >
                  </div>
                </div>
                <div class="form-group row" v-if="producttype == 2">
                  <label class="col-2 text-right">總繳保險費</label>
                  <div class="col-9">
                    <input
                      type="text"
                      maxlength="13"
                      class="form-control form-control-inline"
                      :class="{ 'is-invalid': errors.has(`sum_pay_prem`) }"
                      data-vv-name="sum_pay_prem"
                      v-number.lazy.clear
                      v-validate="'decimal:2'"
                      v-model="editData.sum_pay_prem"
                      @input="checkDecimal2(editData.sum_pay_prem, 'sum_pay_prem')"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right"> 次被保人 </label>
                  <div class="col-9">
                    <div
                      class="mb-2"
                      v-for="(person, i) in editData.csidno2"
                      :key="i"
                    >
                      <template
                        v-if="
                          isCsidnoNotInOptions(person.csidno, options.families)
                        "
                      >
                        <span class="mr-3">
                          <b class="text px-3 text-green">{{
                            getPersonName(
                              options.customCsidno2Families,
                              person.csidno
                            ) | truncate
                          }}</b>
                          <a
                            class="btn btn-red m-0"
                            @click="
                              editData.csidno2.splice(i, 1);
                              !editData.csidno2.length && addCsidno2(0);
                            "
                            >刪除</a
                          >
                        </span>
                      </template>
                      <template v-else>
                        <select
                          class="form-control form-control-inline form-wide"
                          :class="{
                            'is-invalid':
                              editData.csidno &&
                              person.csidno === editData.csidno
                          }"
                          v-model="person.csidno"
                          @change="(e) => onCsidno2Change(e.target.value, i)"
                          alt="ch"
                        >
                          <option value="">請選擇</option>
                          <option
                            v-for="(item, index) in options.families"
                            :key="'csidno2' + index"
                            :value="item.csidno"
                          >
                            {{ item.name | truncate }}
                          </option>
                          <!--<option value="search">選擇現有客戶</option>-->
                        </select>
                      </template>
                      <div class="d-inline">
                        <label>與主被保人的關係為</label>
                      </div>
                      <select
                        class="form-control form-control-inline"
                        :data-vv-name="`relatedtoprimaryinsured${i}`"
                        :class="{
                          'is-invalid': errors.has(
                            `relatedtoprimaryinsured${i}`
                          )
                        }"
                        :disabled="!person.csidno"
                        v-validate="person.csidno ? 'required' : ''"
                        v-model="person.relatedtoprimaryinsured"
                      >
                        <option value="">請選擇</option>
                        <option
                          v-for="(name, value) in options.relationship"
                          :key="'csidno2_relative_' + value"
                          :value="value"
                        >
                          {{ name }}
                        </option>
                      </select>

                      <div
                        class="btn btn-icon btn-border-green m-0"
                        v-if="i == editData.csidno2.length - 1"
                        @click="addCsidno2(i)"
                      >
                        <i class="icon-add_new text-green"></i>
                      </div>
                      <div
                        class="btn btn-icon btn-border-green m-0"
                        v-else
                        @click="editData.csidno2.splice(i, 1)"
                      >
                        <i class="icon-close text-red"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" v-model="confirm_checkbox" id="edit_is_permit" />
                    <label class="text-red" for="edit_is_permit">
                      已確實取得客戶(準客戶)同意，進行資料編輯
                    </label>
                  </div>
                </div>
                <div class="form-group mt-2">
                  <div class="error-block">
                    <div class="error text-center">
                      ＊註：<span class="text-black"
                        >外幣保單之保額、保費、保價請以原幣別輸入</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="action mt-2 text-right">
                <button
                  type="button"
                  class="btn btn-default"
                  @click="cancelAdd()"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  v-if="$route.query.canBackToMenu"
                  @click="toMenu()"
                >
                  回上一步
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="doConfirm()"
                >
                  確定
                </button>
              </div>
            </form>
          </div>
          <mv-pop-up-product-prompt
            :open="mvPopUpProductPrompt"
            @close="panelClose('mvPopUpProductPrompt')"
          />
          <company-merge-modal
            @close="panelClose('mergeModalOpen')"
            :open="mergeModalOpen"
          />
          <search-client-modal
            :open="clientSearchOpen"
            :selDataList="options.families"
            @submit="submitClient"
            @close="cancelClient"
          />
        </div>
        <mv-info
          :open="mvInfoOpen"
          @close="
            panelClose('mvInfoOpen');
            panelOpen('goOnAddOtherCompContractOpen');
          "
        >
          <div class="text font-20" slot="content">
            <div class="mt-10">
              附約被保人非此家戶成員，<br />
              若要編輯或檢視保單可至被保人【<truncate-tool
                :content="csidnoName || $route.query.csidnoName"
              ></truncate-tool
              >】的個人保單資訊頁面
            </div>
          </div>
        </mv-info>
        <go-on-add-other-comp-contract
          :open="goOnAddOtherCompContractOpen"
          @add-other-sub-contract="addOtherSubContract()"
          @add-other-contract="addOtherContract()"
          @finished="finished()"
        >
          <div class="text font-20" slot="content">
            <div class="mt-10">您是否要繼續新增同業保單？</div>
          </div>
        </go-on-add-other-comp-contract>
      </div>
    </div>
    <div v-else>
      <message
        class="mt-5 d-flex justify-content-center"
        loading
        message="資料讀取中，請稍候..."
      />
    </div>
  </div>
</template>

<script>
import ThisMixins from "./Other";
import Message from "./components/Message";
import { queryOtherLifeInsurance } from "@/service";
import mvPopUpProductPrompt from "@/desktop/views/mv/components/mvPopUpProductPrompt.vue";

const SUB_CONTRACT = 2;
const { moment } = window;
export default {
  components: { Message , mvPopUpProductPrompt },
  mixins: [ThisMixins],
  data: () => ({
    producttype:'',
    mvPopUpProductPrompt: false,
    contract_type: SUB_CONTRACT,
    thisROCYear : new Date().getFullYear() - 1911,
    confirm_checkbox: false
  }),
  methods: {
    async addOtherSubContract() {
      this.panelClose("goOnAddOtherCompContractOpen");
      this.$router.push({
        name: this.$route.name,
        query: {
          ...window._.omit(this.$route.query, ["contract_id"]),
          modify: this.modifyContractIDs
        }
      });
      // location.reload()
      // const productid = this.editData.productid;
      this.reset();
      this.subDataInit();
      this.checkRelationsByPolicyID()
      // this.editData.productid = productid;
    },
    addOtherContract() {
      this.panelClose("goOnAddOtherCompContractOpen");
      this.$router.push({
        name: "add-other-comp-contract",
        query: {
          modify: this.modifyContractIDs
        }
      });
    },
    finished() {
      this.panelClose("goOnAddOtherCompContractOpen");
      this.toPolicyEditList({ modify: this.modifyContractIDs });
    },
    subDataInit() {
      this.editData.companyid = this.$route.query.companyid;
      this.editData.csidno = this.$route.query.csidno;
      const rdstdt = moment(this.$route.query.rdstdt);
      this.editData.year = rdstdt.getROCDate("YYYY");
      this.editData.month = rdstdt.getROCDate("MM");
      this.editData.day = rdstdt.getROCDate("DD");
      this.editData.policyid = this.$route.query.policyid;
      this.editData.pay_freq = this.$route.query.pay_freq;
      this.getInsuranceTypes(this.editData.companyid);
    },
    async getCustomFamilies() {
      const res = await queryOtherLifeInsurance({
        contract_id: this.queryContractID,
        policyid: this.$route.query.policyid
      });
      this.options.customApcFamilies = this.options.customCsidnoFamilies = this.options.customCsidno2Families =
        res.body.costom_options;
    },
    doConfirm(){
      if(!this.confirm_checkbox){
        this.$toast.info({title: '未經客戶同意編輯資料'})
        return
      }
      window.trn_cd = "MV_OTHER_INUSURANCE_ADD"
      this.isUpdate ? this.doUpdate() : this.doCreate()
    }
  },
  watch:{
    ready: function(){
      this.registerHanlink()  // for 難字更新
    },
    'options.plan'(newVal) {
      if (newVal.length > 0 && this.editData.sche_nm) {
        // 2026/09/17 [LICRMPA-4834] 若原保單的計畫在商品端已被刪除而比對不到，預設為空字串以匹配「請選擇」選項
        this.editData.sche = newVal.find(
          item => item.NAME === this.editData.sche_nm
        ) || "";
      }
    },
    'options.annual'(newVal) {
      // 2026/09/18 [LICRMPA-4834] 監聽商品年期清單載入
      if (newVal.length > 0 && this.editData.prd) {
        // 檢查原保單記錄的年期 (this.editData.prd) 是否仍存在於商品最新年期清單 (newVal) 中
        const exists = newVal.some(item => item.value === this.editData.prd);
        // 若原年期已在商品端被修改或刪除，將年期設為空字串，使下拉選單預設顯示「請選擇」而非空白
        if (!exists) {
          this.editData.prd = "";
        }
      }
    }
  },
  computed: {
    currentCompany() {
      return this.options.companies.find(
        (x) => x.COMPANYID == this.editData.companyid
      );
    },
    addReady() {
      return (
        !this.isUpdate &&
        !window._.isEmpty(this.options.families) &&
        !window._.isEmpty(this.options.companies)
      );
    },
    updateReady() {
      return (
        this.isUpdate &&
        !window._.isEmpty(this.options.families) &&
        !window._.isEmpty(this.options.companies) &&
        !window._.isEmpty(this.options.insuranceTypes) &&
        !window._.isEmpty(this.options.annual)
      );
    },
    ready() {
      return this.addReady || this.updateReady;
    },
    queryContractID() {
      return this.$route.query.contract_id || this.$route.query.parentContractID;
    },
    insuranceTypesIsExempt(){
      const v = _.get(this.options.insuranceTypes.find((i) => i.PRODUCTID === this.editData.productid), "NAME") ? _.get(this.options.insuranceTypes.find((i) => i.PRODUCTID === this.editData.productid), "NAME") : "" 
      return v.includes('豁免');
    }
  },
  mounted() {
    this.checkRelationsByPolicyID();
    this.getCustomFamilies();
    this.subDataInit();
  }
};
</script>
